module.exports = function() {
  return new Worker(__webpack_public_path__ + "web-worker.8db451550cb14dbce836.js");
};